import React, { useEffect } from "react";

import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";

import Header from "./layouts/Header";
import Footer from "./layouts/Footer";
import PageHeader from "./layouts/PageHeader";
import Gebyrsjekken from "./components/Gebyrsjekken";
import { initializeTextData } from "./util/TextService";

import "./App.css";

function App() {
  const queryClient = new QueryClient();
  const basepath: string = process.env.REACT_APP_PATH || "/";

  useEffect(() => {
    void initializeTextData();
  }, []);

  return (
    <BrowserRouter basename={basepath}>
      <QueryClientProvider client={queryClient}>
        <Header />
        <PageHeader />
        <Gebyrsjekken />
        <Footer />
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export default App;
